<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">
      {{ isEdit ? "编辑分享模板" : "新建分享模板" }}
    </div>

    <div class="content-wrapper">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="template-form"
      >
        <el-form-item label="模板类型">
          <span class="readonly-text">{{ templateTypeText }}</span>
        </el-form-item>

        <el-form-item label="模板名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入模板名称，不超过20个字"
            :maxlength="20"
            style="width: 340px"
          ></el-input>
        </el-form-item>

        <el-form-item label="模板图片" prop="imageUrl">
          <SUpload
            v-model="form.imageUrl"
            accept="image/*"
            type="drag"
            :size="300"
            :show-file-list="false"
          />
          <div class="supload-tips">尺寸建议300 x 280，大小不超过300</div>
          <!-- <div v-if="isSystemPreset" class="form-hint">
            系统预设不支持修改模板图片
          </div> -->
        </el-form-item>

        <el-form-item label="展示排序" prop="sort">
          <el-input-number
            v-model="form.sort"
            :min="0"
            :max="99"
            :step="1"
            step-strictly
          ></el-input-number>
          <div class="form-hint">
            输入数字0–99，数字越小越靠前，数字一致时优先展示最近创建的
          </div>
        </el-form-item>

        <el-form-item label="免费类型" prop="useType">
          <el-radio-group v-model="form.useType">
            <el-radio
              v-for="item in useTypeOptions"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
          <div class="form-hint" v-if="form.useType === 2">
            模版将出现【限时免费】角标
          </div>
        </el-form-item>

        <el-form-item>
          <el-button @click="clickCancel">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="clickSave"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getTemplateTypeText,
  USE_TYPE_OPTIONS,
  TEMPLATE_TYPE_OPTIONS,
} from "./constants";

const LOG_TAG = "[分享模板详情]";
const ADD_OR_EDIT_URL = "/adminapi/v1/shareTemplate/addOrEdit";
// 与列表页约定：后端暂无 detail 接口，编辑数据由列表页写入 sessionStorage
const EDIT_ROW_KEY = "shareTemplateEditRow";
// 当前仅有「跑后模板」一种，固定传 1
const FIXED_TEMPLATE_TYPE = TEMPLATE_TYPE_OPTIONS[0].value;

function buildForm() {
  return {
    id: 0,
    name: "",
    imageUrl: "",
    sort: 0,
    useType: 1,
    status: 1,
  };
}

export default {
  name: "ShareTemplateDetail",

  data() {
    return {
      loading: false,
      submitLoading: false,
      form: buildForm(),
      useTypeOptions: USE_TYPE_OPTIONS,
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        imageUrl: [
          { required: true, message: "请上传模板图片", trigger: "change" },
        ],
      },
    };
  },

  computed: {
    isEdit() {
      return !!this.$route.query.id;
    },
    templateTypeText() {
      return getTemplateTypeText(FIXED_TEMPLATE_TYPE);
    },
  },

  mounted() {
    if (this.isEdit) {
      this.loadDetail(this.$route.query.id);
    }
  },

  methods: {
    loadDetail(id) {
      let row = null;
      try {
        row = JSON.parse(sessionStorage.getItem(EDIT_ROW_KEY) || "null");
      } catch (e) {
        row = null;
      }
      if (!row || Number(row.id) !== Number(id)) {
        this.$util.errorMsg("未获取到该模板信息，请从列表进入编辑");
        this.clickCancel();
        return;
      }
      this.form = Object.assign(buildForm(), {
        id: row.id,
        name: row.name || "",
        imageUrl: row.imageUrl || "",
        sort: Number(row.sort) || 0,
        useType: Number(row.useType) || 1,
        status: row.status === 0 ? 0 : 1,
      });
      // this.isSystemPreset = Number(row.isSystemPreset) === 1;
    },

    clickSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const payload = {
          id: this.isEdit ? Number(this.form.id) : 0,
          templateType: FIXED_TEMPLATE_TYPE,
          name: this.form.name,
          imageUrl: this.form.imageUrl,
          sort: Number(this.form.sort) || 0,
          useType: this.form.useType,
          status: this.form.status,
        };
        this.submitLoading = true;
        this.$http({
          method: "POST",
          url: this.$util.domain + ADD_OR_EDIT_URL,
          body: JSON.stringify(payload),
        })
          .then((res) => {
            const body = res.body || {};
            if (body.error === 10000) {
              this.$util.successMsg("保存成功");
              sessionStorage.removeItem(EDIT_ROW_KEY);
              this.clickCancel();
            } else {
              this.$util.errorMsg(body.message || "保存失败");
            }
          })
          .catch((err) => {
            console.error(LOG_TAG, "保存失败", err);
            this.$util.errorMsg("保存失败");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },

    clickCancel() {
      this.$router.push({ path: "/yunying/user/share/template" });
    },
  },
};
</script>

<style scoped>
.template-form {
  max-width: 720px;
}

.form-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.readonly-text {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// ShareTemplateDetail.vue?81921764